import { Chip } from "@mui/material";
import { UserRequestStatus } from "./userRequestsApi";
import { Localized } from "@fluent/react";

export const UserRequestsStatusChip = ({ status }: { status: UserRequestStatus }) => {
    switch(status) {
        case "NEW":
            return <Chip color="info" label={<Localized id="user-requests-new">_Nowy</Localized>} />
        case "CLOSED":
            return <Chip color="success" label={<Localized id="user-requests-closed">_Zamknięty</Localized>} />
        case "REJECTED":
            return <Chip color="error" label={<Localized id="user-requests-rejected">_Odrzucony</Localized>} />
    }
}